import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AppConfig } from '@config/app.config';
import { GeneralsService } from '@core/services/generals.service';
import { UsersService } from '@core/services/users.service';
import { ValidationsService } from '@core/services/validations.service';
import { Constants } from '@shared/class/constants.class';
import { RolSingle } from '@shared/interfaces/rol';
import { User } from '@shared/interfaces/user';

@Component({
  selector: 'app-users-edit',
  templateUrl: './users-edit.component.html'
})
export class UsersEditComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public user: User;
  public usersList: Array<User> = [];
  public rolesList: Array<RolSingle> = [];
  public userForm: FormGroup;

  constructor(
    public appConfig: AppConfig,
    private generalsService: GeneralsService,
    private usersService: UsersService,
    public dialogRef: MatDialogRef<UsersEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  ngOnInit() {
    if (
      this.data.action === this.appConfig.ACTIONS.edit.id ||
      this.data.action === this.appConfig.ACTIONS.add.id
    ) {
      let rol: RolSingle;
      if (this.data.relationships.length) {
        this.data.relationships.forEach((element: any) => {
          rol = { id: element.id, name: element.attributes.name };
          this.rolesList.push(rol);
        });
      }

      this.constants.title = this.appConfig.LANG.users.title;
      this.constants.action = this.data.action;

      this.userForm = new FormGroup({
        name: new FormControl('', [
          Validators.required,
          ValidationsService.notHaveSpaces
        ]),
        idRol: new FormControl('', Validators.required)
      });
      if (this.constants.action === this.appConfig.ACTIONS.edit.id) {
        this.constants.title =
          this.appConfig.LANG.title.edit + ' ' + this.constants.title;
        this.user = this.data.item;

        this.userForm.addControl(
          'id',
          new FormControl(this.user.id, [Validators.required])
        );
        this.userForm.patchValue({
          id: this.user.id,
          name: this.user.name,
          idRol: this.user.idRol
        });
      } else {
        if (this.rolesList.length <= 0) {
          this.constants.admitted = false;
        } else {
          this.constants.title =
            this.appConfig.LANG.title.add + ' ' + this.constants.title;
        }
      }
    }
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }

  onSubmit() {
    const form = this.userForm;
    if (form.dirty && form.valid) {
      this.generalsService.save(
        this.constants.action,
        form,
        this.dialogRef,
        this.usersService
      );
    } else {
      this.close();
    }
  }

  close() {
    this.dialogRef.close(300);
  }
}
